<template>
    <div>
        <!-- <button class="btn btn-sm btn-warning px-3 ml-2">ใบปะหน้า</button> -->
        <b-dropdown-item v-for="(size , i) in labelSize" :key="i"
            :href="setTypeUrlLabel( size.key, false )" 
            target="_blank" >
            {{size.name}}
        </b-dropdown-item>
    </div>
</template>
<script>
export default {
    name:'BtnLabel',
    props:{
        labelId: [String , Number]
    },
    data(){
        return {
            labelSize:[
                {
                    key: 'A4',
                    name: 'A4'
                },
                {
                    key: 'A5',
                    name: 'A5'
                },
                {
                    key: 'A6',
                    name: 'A6'
                },
                {
                    key: 'receipt',
                    name: 'ใบเสร็จ'
                },
                {
                    key: 'letter',
                    name: 'ซองจดหมาย'
                },
                {
                    key: 'letter4x6',
                    name: 'ซองจดหมาย ขนาด 4*6'
                },
                {
                    key: 'sticker',
                    name: 'ขนาดสติกเกอร์ 8x8 เซนติเมตร'
                },
                {
                    key: 'sticker4x6',
                    name: 'ขนาดสติกเกอร์ 4x6 นิ้ว'
                },
                {
                    key: 'paperang',
                    name: 'Paperang'
                },
            ]
        }
    },
    methods:{
        setTypeUrlLabel( size , dropoff ){
            let url = `#/label/${this.labelId}/${size}`
            if( dropoff ){
                url = url+'/dropoffShippop'
            }
            return url
        }
    }
}
</script>